/**
 * /dashboard/accounting/purchases — Purchases hub (G_ACC5).
 *
 * Bill list with filters + MSME-overdue badges.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/purchases/page.tsx.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { BillList } from "@/components/accounting/bill-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/accounting/purchases/")({
  component: PurchasesHubRoute,
});

function PurchasesHubRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <AccountingModuleShell
      title="Purchases"
      description="Bills from your vendors. MSME-flagged contacts trigger the 45-day clock."
      actions={
        <Button asChild className="gap-1.5">
          <Link to="/app/$tenantSlug/accounting/purchases/new" params={{ tenantSlug }}>
            <Plus aria-hidden className="h-4 w-4" />
            New bill
          </Link>
        </Button>
      }
    >
      <BillList />
    </AccountingModuleShell>
  );
}
